import React, { useEffect, useState } from "react";
import DataTable from "../Tables/DataTable";

import SpectrumChart from "../Charts/SpectrumChart";
import HistogramChart from "../Charts/HistogramChart";
import {
    CreateHistogramPoints,
    CreateSpectrumPoints,
} from "../../utils/CreatePoints";
import { Trans, useTranslation } from "react-i18next";
import StepsNavButtons from "../Buttons/StepsNavButtons";
import { SPECTRUM_POINTS_BOUNDARY } from "../../utils/constants";
import { isEmpty } from "lodash";

const ManageData = ({
    data,
    dataFileName,
    dataReference,
    dataReferenceFileName,
    setData,
    nextStep,
    prevStep,
    modifiedDataReference,
    setModifiedDataReference,
    nextStepButtonText,
}) => {
    const [activeTab, setActiveTab] = useState(0);
    const [selectedRows, setSelectedRows] = useState([]);
    const [deletedPoints, setDeletedPoints] = useState([]);
    const [spectrumPoints, setSpectrumPoints] = useState([]);
    const [selectedSpectrumPoints, setSelectedSpectrumPoints] = useState([]);
    const [histogramPoints, setHistogramPoints] = useState([]);

    const [isFilterUsed, setIsFilterUsed] = useState(false);
    const [filteredRows, setFilteredRows] = useState([]);
    const [isSpectrumDisabled, setIsSpectrumDisabled] = useState(false);
    const [isWavenumber, setIsWavenumber] = useState(true);

    const { t } = useTranslation();

    const tabs = [t("data"), t("spectrum"), t("histogram")];

    useEffect(() => {
        if (data && data.rows) {
            setSpectrumPoints(CreateSpectrumPoints(data));
            if (data.rows?.length <= SPECTRUM_POINTS_BOUNDARY) {
                setIsSpectrumDisabled(false);
            } else {
                setIsSpectrumDisabled(true);
            }
        } else {
            setSpectrumPoints([]);
        }
    }, [data]);

    useEffect(() => {
        if (isFilterUsed && filteredRows?.length <= SPECTRUM_POINTS_BOUNDARY) {
            setIsSpectrumDisabled(false);
        } else if (
            !isFilterUsed &&
            data?.rows?.length > SPECTRUM_POINTS_BOUNDARY
        ) {
            setIsSpectrumDisabled(true);
        }
    }, [filteredRows, isFilterUsed]);

    useEffect(() => {
        if (modifiedDataReference) {
            setHistogramPoints(CreateHistogramPoints(modifiedDataReference));
        } else {
            setHistogramPoints([]);
        }
    }, [modifiedDataReference]);

    const renderTabs = () => {
        return (
            tabs &&
            tabs.map((tab, index) => {
                return (
                    <div
                        key={index}
                        onClick={() => {
                            setActiveTab(index);
                        }}
                        className={`tabs-bnt-item ${
                            activeTab === index ? "active" : ""
                        }`}
                        data-tabs="data-content-wrapper"
                    >
                        {tab}
                    </div>
                );
            })
        );
    };

    const isNextStepDisabled = () => {
        return isEmpty(data?.rows);
    };

    return (
        <>
            <div className="steps step3 show" id="step-one">
                <div className="title-with-desc-section">
                    <ul className="Uploaded-files-area m-0 p-0">
                        {dataFileName && (
                            <li className="flex items-center mb-2">
                                <span className="mr-2 font-medium blue-color">
                                    <Trans i18nKey="measurement">
                                        Measurement
                                    </Trans>
                                    :
                                </span>
                                <span>{dataFileName}</span>
                            </li>
                        )}
                        {dataReferenceFileName && (
                            <li className="flex items-center mb-2">
                                <span className="mr-2 font-medium blue-color">
                                    <Trans i18nKey="reference">Reference</Trans>
                                    :
                                </span>
                                <span>{dataReferenceFileName}</span>
                            </li>
                        )}
                    </ul>
                </div>
                <div className="card-table shadow mb-5">
                    <div className="tabs-wrapper">
                        <div className="tabs-btn">{renderTabs()}</div>
                        <div className="tabs-content">
                            <DataTable
                                visible={activeTab === 0}
                                data={data}
                                dataReference={dataReference}
                                selectedRows={selectedRows}
                                setSelectedRows={setSelectedRows}
                                selectedSpectrumPoints={selectedSpectrumPoints}
                                setSelectedSpectrumPoints={
                                    setSelectedSpectrumPoints
                                }
                                setData={setData}
                                dataFileName={dataFileName}
                                deletedPoints={deletedPoints}
                                setDeletedPoints={setDeletedPoints}
                                modifiedDataReference={modifiedDataReference}
                                setModifiedDataReference={
                                    setModifiedDataReference
                                }
                                setIsFilterUsed={setIsFilterUsed}
                                setFilteredRows={setFilteredRows}
                                isWavenumber={isWavenumber}
                                setIsWavenumber={setIsWavenumber}
                                showSpectraOptions={false}
                            />

                            <SpectrumChart
                                visible={activeTab === 1}
                                points={spectrumPoints}
                                selectedRows={selectedRows}
                                setSelectedRows={setSelectedRows}
                                deletedPoints={deletedPoints}
                                setDeletedPoints={setDeletedPoints}
                                isFilterUsed={isFilterUsed}
                                filteredRows={filteredRows}
                                isSpectrumDisabled={isSpectrumDisabled}
                                isWavenumber={isWavenumber}
                                setIsWavenumber={setIsWavenumber}
                                renderSwitch={false}
                            />

                            <HistogramChart
                                visible={activeTab === 2}
                                points={histogramPoints}
                                isFilterUsed={isFilterUsed}
                                filteredRows={filteredRows}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <StepsNavButtons
                back={{ action: prevStep }}
                next={{
                    action: nextStep,
                    label: nextStepButtonText,
                    disabled: isNextStepDisabled(),
                }}
            />
        </>
    );
};

export default ManageData;
